import { MotionDiv } from '@/components/element/MotionDiv';
import { Link, useLocation, useParams } from 'react-router-dom';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useEffect, useState } from 'react';
import { PurchaseOrderLogic, SalesOrderLogic, TeamMemberLogic } from '@/hooks/api/models/logics';
import { SimpleTextFormat, SimpleTextFormatWithLink } from '@/components/element/SimpleTextFormat';
import { useCurrentPaymentTask } from '@/providers/PaymentTaskProvider';

export const ProjectInfo = () => {
  const { _w_, _t_, me, meTeamMember } = useCurrentTeamMember();
  const { purchase_order_id } = useParams();
  const { paymentTask: task } = useCurrentPaymentTask();
  const [editable, setEditable] = useState<boolean>(false);

  useEffect(() => {
    if (task) {
      setEditable(PurchaseOrderLogic.canUpdate(_t_!, task.purchase_order, me!));
    }
  }, [task]);

  return (
    <MotionDiv className="card mb-4">
      <div className="card-header d-flex align-items-center justify-content-between">
        <div>
          <h6 className="mb-0">プロジェクト概要</h6>
        </div>
      </div>
      <div className="card-body pt-0">
        <div className="d-flex align-items-center justify-content-between">
          <div className="text-secondary text-xs px-0 font-weight-bold me-3">プロジェクト名</div>
          <div className="font-weight-bold text-end px-0 text-sm text-dark text-truncate">
            {editable ? (
              <Link
                to={`/w/${_w_!.identifier}/teams/${_t_!.id}/purchase_orders/${purchase_order_id}`}
                className="text-decoration-underline"
              >
                {task!.purchase_order.name}
              </Link>
            ) : (
              <>{task!.purchase_order.name}</>
            )}
          </div>
        </div>
        <hr className="horizontal dark" />
        <div className="d-flex align-items-center justify-content-between">
          <div className="text-secondary text-xs font-weight-bold pe-2">チーム名</div>
          <div className="font-weight-bold text-end px-0 text-sm text-dark">
            {task!.purchase_order.team_outline.name}
          </div>
        </div>
        <hr className="horizontal dark" />
        <div className="d-flex align-items-center justify-content-between">
          <div className="text-secondary text-xs px-0 font-weight-bold">プロジェクト担当者</div>
          <div className="d-flex align-items-center">
            <img
              src={task!.purchase_order.user.user_account.icon_file_url}
              className="avatar avatar-xs rounded-circle me-1"
            />
            <div className="font-weight-bold px-0 text-sm text-dark">{task!.purchase_order.user.user_account.name}</div>
          </div>
        </div>
        <hr className="horizontal dark" />
        <div className="d-flex align-items-center justify-content-between">
          <div className="text-secondary text-xs px-0 font-weight-bold">発注先</div>
          <div className="font-weight-bold text-end px-0 text-sm text-dark">
            {task!.purchase_order.business_partner.display_name}
          </div>
        </div>
        <hr className="horizontal dark" />
        <div className="d-flex align-items-center justify-content-between">
          <div className="text-secondary text-xs px-0 font-weight-bold">支払方法</div>
          <div className="font-weight-bold text-end px-0 text-sm text-dark">
            {task!.purchase_order.payment_method.label}
          </div>
        </div>
        <hr className="horizontal dark" />
        <div className="d-flex align-items-center justify-content-between">
          <div className="text-secondary text-xs font-weight-bold pe-2">振込先情報</div>
          <div className="px-0 text-xs break-word">
            <SimpleTextFormat content={task!.purchase_order.transfer_information || ''} />
          </div>
        </div>
        <hr className="horizontal dark" />
        <div className="d-flex align-items-center justify-content-between">
          <div className="text-secondary text-xs font-weight-bold pe-2">支払タスク処理マニュアル</div>
          <div className="px-0 text-xs break-word">
            <SimpleTextFormatWithLink content={task!.purchase_order.task_procedure_manual || ''} />
          </div>
        </div>
      </div>
    </MotionDiv>
  );
};
